import styled from 'styled-components';
import { BREAKPOINTS, SPACING } from '../../style';

export const ServicesContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: ${SPACING.lg};
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: ${SPACING.md};
  margin-top: ${SPACING.md};

  @media (max-width: ${BREAKPOINTS.mobile}) {
    grid-template-columns: 1fr;
  }
`;